import { render, staticRenderFns } from "./BulkEdit.vue?vue&type=template&id=5b098ddb&scoped=true&"
import script from "./BulkEdit.vue?vue&type=script&lang=js&"
export * from "./BulkEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b098ddb",
  null
  
)

export default component.exports